export default function getImgSrc(url) {
  return url.indexOf('http') === 0
    ? url
    : require(`@/assets/images/${ url }`)
}